import { useMemo } from "react";

import KeyValue from "components/KeyValue";
import EmptyState from "ds/components/EmptyState";
import { EmptystateUsersColored } from "components/icons/generated";

import { ModuleShareNewFormFields } from "../types";
import NewModuleSummaryValueList from "./ValueList";

type NewModuleSummaryShareProps = {
  data: ModuleShareNewFormFields;
};

const NewModuleSummaryShareNew = ({ data }: NewModuleSummaryShareProps) => {
  const sharedSpacesValues = useMemo(
    () => data.sharedSpaces?.filter((space) => space.value).map((space) => space.value),
    [data.sharedSpaces]
  );

  return (
    <>
      {!!sharedSpacesValues?.length && (
        <KeyValue name="Spaces">
          <NewModuleSummaryValueList values={sharedSpacesValues} />
        </KeyValue>
      )}
      {!sharedSpacesValues?.length && (
        <EmptyState
          padding="large"
          icon={EmptystateUsersColored}
          title="This module is not shared with any spaces"
          caption="Use the spaces list to share this module with other spaces."
        />
      )}
    </>
  );
};

export default NewModuleSummaryShareNew;
